import React from 'react';
import PillarLayout from './PillarLayout';
import type { LayoutProps } from './types';

/**
 * Layout — renders PillarLayout for all authenticated pages.
 *
 * The legacy dropdown-based navigation (LegacyLayout) was removed
 * in the Spec 148 cleanup. The pillarNav feature flag is always true
 * and was never togglable from the backend.
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  return <PillarLayout>{children}</PillarLayout>;
};

export default Layout;
